<template>
  <v-container fluid>
    <v-row dense>
      <v-col
        v-if="!this.$store.state.auth.user.cargoTypeID"
        class="pb-0"
      >
        <CargoTypeSelector
          v-model="cargoTypeID"
          dense
          :can-any="true"
          @input="onFilterChanged"
        />
      </v-col>

      <v-col class="pb-0">
        <RequestTypeSelector
          v-model="requestTypeID"
          dense
          :can-any="true"
          @input="onFilterChanged"
        />
      </v-col>

      <v-col class="pb-0">
        <v-text-field
          v-model="numberContains"
          dense
          append-icon="mdi-magnify"
          label="№ заявки содержит"
          single-line
          hide-details
          autocomplete="off"
          class="pb-4"
          @input="lazyQuery(onFilterChanged)"
        />
      </v-col>

      <v-col class="pb-0">
        <PeriodSelector
          v-model="period"
          dense
          @input="onFilterChanged"
        />
      </v-col>

      <v-col class="pb-0">
        <RequestStatusSelector
          v-model="requestStatusID"
          dense
          :can-any="true"
          @input="onFilterChanged"
        />
      </v-col>
    </v-row>

    <v-row
      dense
      class="pb-2"
      align="center"
    >
      <v-col>
        <v-text-field
          v-model="carContains"
          dense
          append-icon="mdi-magnify"
          label="Машина содержит"
          single-line
          hide-details
          autocomplete="off"
          class="my-0"
          @input="lazyQuery(onFilterChanged)"
        />
      </v-col>

      <v-col>
        <v-text-field
          v-model="driverContains"
          dense
          append-icon="mdi-magnify"
          label="Водитель содержит"
          single-line
          hide-details
          autocomplete="off"
          class="my-0"
          @input="lazyQuery(onFilterChanged)"
        />
      </v-col>

      <v-tooltip>
        <template v-slot:activator="{on, attrs}">
          <div
            v-bind="attrs"
            v-on="on"
          >
            <v-switch
              v-model="withoutCars"
              dense
              hide-details
              class="my-0 pl-4 pr-1"
              label="Без машин"
              @change="onFilterChanged"
            />
          </div>
        </template>
        <span>Показывать заявки по которым нет привязки к машине</span>
      </v-tooltip>
    </v-row>

    <v-data-table
      dense
      :items="items"
      :headers="headers"
      :loading="loading"
      :server-items-length="rows"
      hide-default-footer
      disable-pagination
      disable-filtering
      disable-sort
      item-key="id"
      loading-text="Загрузка данных..."
      no-data-text="Нет заявок, соответствующих фильтру..."
      no-results-text="Совпадений не найдено..."
      class="styled-table pointed-table"
      @click:row="requestClick"
    >
      <template v-slot:[`item.date`]="{item}">
        {{ item.date | dateFormat }}
      </template>

      <template v-slot:[`item.actions`]="{item}">
        <template v-if="canDelete(item)">
          <v-icon
            color="red"
            @click.stop="deleteRequest(item)"
          >
            mdi-delete
          </v-icon>
        </template>
      </template>
    </v-data-table>

    <v-pagination
      v-if="pageCount && pageCount > 1"
      v-model="page"
      :length="pageCount"
      total-visible="6"
      class="tableHeader"
      @input="onPageChanged"
    />

    <RowsSelector
      v-model="rows"
      @input="onRowsChanged"
    />

    <!-- кнопка добавить -->
    <RequestsAddButton
      v-if="canAdd"
      :loading="loading"
      @click="addClick($event)"
    />
  </v-container>
</template>

<script>
import CargoTypeSelector from "@/components/CargoTypeSelector"
import RequestsAddButton from "@/views/RequestsDirectory/RequestsAddButton"
import RequestStatusSelector from "@/components/RequestStatusSelector"
import RequestTypeSelector from "@/components/RequestTypeSelector"
import RowsSelector from "@/components/RowsSelector"
import PeriodSelector from "@/components/PeriodSelector"
import saveState from "@/utils/saveState"
import lazyQuery from "@/utils/lazyQuery"

export default {
  components: {
    RowsSelector,
    CargoTypeSelector,
    RequestStatusSelector,
    RequestTypeSelector,
    PeriodSelector,
    RequestsAddButton
  },

  mixins: [saveState, lazyQuery],
  data: () => ({
    loading: false,
    mounted: false,
    // пагинация
    page: 1,
    pageCount: 1,
    rows: 1,
    // фильтр
    cargoTypeID: 0,
    requestTypeID: 0,
    numberContains: "",
    period: { dateFrom: "", dateTo: "" },
    requestStatusID: 0,
    carContains: "",
    driverContains: "",
    withoutCars: true,
    // элементы
    items: [],

    headers: [
      { text: "Тип заявки", value: "requestType.name", class: "tableHeader tableHeaderText--text" },
      { text: "№ заявки", value: "number", class: "tableHeader tableHeaderText--text" },
      { text: "Дата", value: "date", class: "tableHeader tableHeaderText--text" },
      { text: "№ машины", value: "car", class: "tableHeader tableHeaderText--text" },
      { text: "Водитель", value: "driver", class: "tableHeader tableHeaderText--text" },
      { text: "Статус", value: "requestStatus.name", class: "tableHeader tableHeaderText--text" },
      { text: "", value: "actions", sortable: false, width: "48px", class: "tableHeader tableHeaderText--text" }
    ]
  }),

  computed: {
    canAdd() {
      return this.$store.state.auth.user.role === "Клиент" || this.$store.state.auth.user.role === 'Администратор'
              || this.$store.state.auth.user.role === 'Управляющий'
    }
  },

  created() {
    // столбец с типом груза только для тех, кто видит разные
    if (!this.$store.state.auth.user.cargoTypeID) {
      this.headers.splice(0, 0, {
        text: "Тип груза",
        value: "cargoType.name",
        class: "tableHeader tableHeaderText--text"
      })
    }
  },

  mounted() {
    this.mounted = true
    this.getPageCount().then(() => this.getItems())
  },

  methods: {
    saveStateConfig() {
      return {
        saveKey: "requests",
        saveProperties: [
          "cargoTypeID",
          "requestTypeID",
          "numberContains",
          "period",
          "requestStatusID",
          "carContains",
          "driverContains",
          "withoutCars",
          "page"
        ]
      }
    },

    // количество страниц данных для пагинации
    async getPageCount() {
      const response = await this.axios.get("/requests/getPageCount", {
        params: {
          rowsPerPage: this.rows,
          // filter:
          cargoTypeID: this.cargoTypeID,
          carContains: this.carContains,
          numberContains: this.numberContains,
          driverContains: this.driverContains,
          withoutCars: this.withoutCars,
          requestStatusID: this.requestStatusID,
          requestTypeID: this.requestTypeID,
          dateFrom: this.period.dateFrom,
          dateTo: this.period.dateTo
        }
      })
      this.pageCount = response.data
    },

    // получение данных
    getItems() {
      this.loading = true
      if (this.page > this.pageCount && this.page !== 1) this.page = this.pageCount
      this.axios
        .get("/requests/get", {
          params: {
            page: this.page,
            rowsPerPage: this.rows,
            // filter:
            cargoTypeID: this.cargoTypeID,
            requestTypeID: this.requestTypeID,
            numberContains: this.numberContains,
            dateFrom: this.period.dateFrom,
            dateTo: this.period.dateTo,
            requestStatusID: this.requestStatusID,
            carContains: this.carContains,
            driverContains: this.driverContains,
            withoutCars: this.withoutCars
          }
        })
        .then((response) => {
          this.items = response.data
          this.loading = false
        })
        .catch((err) => {
          this.$router.push(`/error?message=Ошибка при получении списка заявок&&error=${err}`)
        })
    },

    onFilterChanged() {
      this.page = 1
      this.getPageCount().then(() => this.getItems())
    },

    onPageChanged() {
      this.getItems()
    },

    onRowsChanged() {
      if (!this.mounted) return
      this.page = 1
      this.getPageCount().then(() => this.getItems())
    },

    // редактирование
    requestClick(request) {
      this.$router.push(`/request/${request.id}`)
    },

    // добавление заявки
    addClick(id) {
      this.$router.push(`/request?requestType=${id}`)
    },

    // проверка доступности удаления
    canDelete(request) {
      return (
        request.requestStatusID === 10 ||
        (request.requestStatusID === -10 && // Получена или Ошибка
          (this.$store.state.auth.user.role === "Клиент" || this.$store.state.auth.user.role === "Администратор"
          || this.$store.state.auth.user.role === "Управляющий"))
      )
    },

    async deleteRequest(request) {
      if (
        !(await this.$messageBox(
          `Удалить заявку №
          <span class="accent--text">
          ${request.number}
          </span> от <span class="accent--text">${this.$dateFormat(request.date)}</span>,<br>
          водитель <span class="accent--text">${request.driver}</span>?`
        ))
      ) {
        return
      }
      this.loading = true
      await this.axios.delete(`/requests/delete/${request.id}`).catch(() => {
        this.$router.push("/error?message=Ошибка при удалении заявки")
      })
      this.getItems()
    }
  }
}
</script>
